import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const HeaderCom = () => {
    const [text, setText] = useState('');
    const fullText = 'C:\\Users\\Web> Greetings! I\'m Asad, a front-end developer...';
    const [text1, setText1] = useState('');
    const fullText1 = 'C:\\Users\\Web> color a';
    const [isFirstTextComplete, setIsFirstTextComplete] = useState(false);
    const [isCursorVisible, setIsCursorVisible] = useState(false);

    useEffect(() => {
        let index = 0;
        const typingInterval = setInterval(() => {
            if (index < fullText1.length) {
                setText1(prev => prev + fullText1[index]);
                index++;
            } else {
                clearInterval(typingInterval);
                setIsFirstTextComplete(true);
                setIsCursorVisible(true);
            }
        }, 60);

        return () => clearInterval(typingInterval);
    }, []);

    useEffect(() => {
        if (isFirstTextComplete) {
            setTimeout(() => {
                let index = 0;
                const typingInterval = setInterval(() => {
                    if (index < fullText.length) {
                        setText(prev => prev + fullText[index]);
                        index++;
                    } else {
                        clearInterval(typingInterval);
                    }
                }, 60);

                return () => clearInterval(typingInterval);
            }, 200);
        }
    }, [isFirstTextComplete]);

    useEffect(() => {
        const startBlinking = () => {
            const blinkInterval = setInterval(() => {
                setIsCursorVisible(prev => !prev);
            }, 500);

            return () => clearInterval(blinkInterval);
        };

        const blinkDelay = setTimeout(startBlinking, 2100); // 2-second delay before starting the blink effect

        return () => clearTimeout(blinkDelay);
    }, []);

    return (
        <Header>
            <h1 className="spinn">
                <Paragraph className="parag" isCompleted={isFirstTextComplete}>
                    <p>{text1}</p>
                    <br />
                    <p>{text}
                     {isCursorVisible && '|'}</p>

                </Paragraph>
                <br/>
            </h1>
        </Header>
    );
};

const Header = styled.div`
  width: 97%;
  margin: auto;
  font-family: Consolas, monospace;
  color: white;
  background-color: black;
`;

const Paragraph = styled.p`
  color: ${(props) => (props.isCompleted ? '#03ff2c' : 'white')};
  display: flex;
  flex-direction: column;
  font-family: Consolas, monospace;
  @media  (max-width:678px){
  p{
    font-size: 1.5rem !important;
  }
}
`;

export default HeaderCom;
